var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "500" } },
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("disable-two-factor-auth")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: {
                      password: "",
                      label: _vm.$ct("enter-password-to-confirm"),
                      disabled: _vm.inputsDisabled,
                    },
                    model: {
                      value: _vm.password,
                      callback: function ($$v) {
                        _vm.password = $$v
                      },
                      expression: "password",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "danger",
              attrs: { disabled: _vm.inputsDisabled },
              on: {
                click: function ($event) {
                  return _vm.cancel()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: _vm.confirmDisabled },
              on: {
                click: function ($event) {
                  return _vm.submit()
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$ct("common.confirm")) + " ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }